"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.string.starts-with");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/web.dom.iterable");
var _popupConfig = require("@/api/popup/popupConfig.js");
var _decorateConfig = require("@/api/decorate/decorateConfig.js");
var _memberManagement = require("@/api/member/memberManagement.js");
var _decorateConfigItem = require("@/api/decorate/decorateConfigItem.js");
var _shopList = require("@/api/shop/shopList.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'BackgroundImageConfiguration',
  props: {
    pageKey: {
      type: String,
      default: ''
    },
    moduleKey: {
      type: String,
      default: ''
    },
    xcxType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      imagePrefix: '',
      id: null,
      // 列表相关
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      loading: false,
      // 选择的行
      selectedRows: [],
      // 对话框相关
      dialogVisible: false,
      dialogTitle: '',
      isEdit: false,
      currentId: null,
      // 预览弹窗相关
      previewVisible: false,
      previewImageUrl: '',
      // 表单数据
      formData: {
        name: '',
        imageUrl: '',
        type: 0,
        enable: true,
        startTime: '',
        endTime: '',
        shopids: [] // 添加shopids字段来记录选中的ID
      },
      timeRange: [],
      // 合并的时间范围
      // 表单验证规则
      rules: {
        name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }],
        imageUrl: [{
          required: true,
          message: '请上传背景图',
          trigger: 'change'
        }],
        type: [{
          required: true,
          message: '请选择类型',
          trigger: 'change'
        }],
        shopids: [{
          required: true,
          message: '请选择门店或城市',
          trigger: 'change',
          validator: this.validateShopIds
        }]
      },
      // 搜索表单
      searchForm: {
        name: ''
      },
      // 门店和区域数据
      storeList: [],
      regionList: []
    };
  },
  watch: {},
  created: function created() {
    // 组件创建时可以访问到传入的key值
    console.log('BackgroundImageConfiguration - pageKey:', this.pageKey, 'moduleKey:', this.moduleKey);
    // 获取图片前缀
    this.getImagePrefix();
    // 页面加载时获取已保存的配置
    this.loadConfig();
    // 获取门店和区域数据
    this.loadStoreAndRegionData();
  },
  methods: {
    handleTypeChange: function handleTypeChange() {
      this.formData.shopids = []; // 更改类型后清空shopids
    },
    // 处理表格选择变化
    handleSelectionChange: function handleSelectionChange(selection) {
      var _this = this;
      // 如果选择的数量大于1（可能是用户点击了全选），则只保留第一条记录
      if (selection.length > 1) {
        // 只选择第一条记录
        var firstSelected = selection[0];
        this.selectedRows = [firstSelected];

        // 清除其他选择，只保留第一条
        this.$nextTick(function () {
          _this.list.forEach(function (row, index) {
            if (index !== 0) {
              _this.$refs.table.toggleRowSelection(row, false);
            }
          });
        });
      } else {
        this.selectedRows = selection;
      }
    },
    // 控制选择框是否可选
    checkSelectable: function checkSelectable(row, index) {
      // 如果已经有选中的行且当前行不是已选中的行，则不可选
      // 但允许选择第一行（索引为0），以支持全选时默认选择第一个
      if (this.selectedRows.length >= 1 && !this.selectedRows.includes(row)) {
        return false;
      }
      return true;
    },
    // 确认保存
    confirmSave: function confirmSave() {
      var _this2 = this;
      this.$confirm('保存后将替换正在使用的配置，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 用户点击确定，执行保存操作
        _this2.handleSave();
      }).catch(function () {
        // 用户点击取消，不执行任何操作
        _this2.$message.info('已取消保存');
      });
    },
    // 获取图片前缀
    getImagePrefix: function () {
      var _getImagePrefix2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _memberManagement.getImagePrefix)();
            case 1:
              response = _context.sent;
              if (response.code === 200 && response.data) {
                this.imagePrefix = response.data;
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('获取图片前缀失败:', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getImagePrefix() {
        return _getImagePrefix2.apply(this, arguments);
      }
      return getImagePrefix;
    }(),
    // 获取图片完整URL
    getImageUrl: function getImageUrl(url) {
      // 如果没有url则返回空
      if (!url) return '';

      // 如果已经是完整URL则直接返回
      if (url.startsWith('http')) {
        return url;
      }

      // 如果有图片前缀，使用图片前缀
      if (this.imagePrefix) {
        // 确保前缀末尾没有斜杠，url开头有斜杠
        var prefix = this.imagePrefix.endsWith('/') ? this.imagePrefix.slice(0, -1) : this.imagePrefix;
        var path = url.startsWith('/') ? url : '/' + url;
        return prefix + path;
      }

      // 如果是相对路径，则加上基础URL
      return url;
    },
    triggerSelect: function triggerSelect() {
      this.$refs.fileInput.click();
    },
    handleFileChange: function () {
      var _handleFileChange = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(event) {
        var file, loading, response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = event.target.files && event.target.files[0];
              if (file) {
                _context2.next = 1;
                break;
              }
              return _context2.abrupt("return");
            case 1:
              if (this.validateImage(file)) {
                _context2.next = 2;
                break;
              }
              event.target.value = '';
              return _context2.abrupt("return");
            case 2:
              // 显示上传loading
              loading = this.$loading({
                lock: true,
                text: '图片上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              }); // 调用uploadPopupImage接口上传图片
              _context2.prev = 3;
              _context2.next = 4;
              return (0, _popupConfig.uploadPopupImage)(file);
            case 4:
              response = _context2.sent;
              loading.close();
              if (response.code === 200 && response.data) {
                this.formData.imageUrl = response.data;
                this.$message.success('图片上传成功');
              } else {
                this.$message.error(response.message || '图片上传失败');
              }
              _context2.next = 6;
              break;
            case 5:
              _context2.prev = 5;
              _t2 = _context2["catch"](3);
              loading.close();
              console.error('图片上传失败:', _t2);
              this.$message.error('图片上传失败: ' + (_t2.message || '未知错误'));
            case 6:
              // 允许重复选择同一文件
              event.target.value = '';
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[3, 5]]);
      }));
      function handleFileChange(_x) {
        return _handleFileChange.apply(this, arguments);
      }
      return handleFileChange;
    }(),
    validateImage: function validateImage(file) {
      var isImage = file.type && file.type.startsWith('image/');
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB!');
        return false;
      }
      return true;
    },
    removeImage: function removeImage() {
      this.formData.imageUrl = '';
    },
    handleSave: function () {
      var _handleSave = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var data, _loading, response, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              data = {
                id: this.id,
                pageCode: this.pageKey,
                optionCode: this.moduleKey,
                configInfo: this.formData.imageUrl
              }; // 显示保存loading状态
              _loading = this.$loading({
                lock: true,
                text: '保存中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              }); // 调用后端接口保存配置
              _context3.next = 1;
              return (0, _decorateConfig.saveDecorateConfig)(data);
            case 1:
              response = _context3.sent;
              // 关闭loading
              _loading.close();
              if (!(response.code === 200)) {
                _context3.next = 3;
                break;
              }
              this.$message.success('配置保存成功');
              // 保存成功后更新ID
              if (response.data && response.data.id) {
                this.id = response.data.id;
              }
              // 保存成功后重新加载配置
              _context3.next = 2;
              return this.loadConfig();
            case 2:
              _context3.next = 4;
              break;
            case 3:
              this.$message.error(response.message || '保存失败!');
            case 4:
              _context3.next = 6;
              break;
            case 5:
              _context3.prev = 5;
              _t3 = _context3["catch"](0);
              // 关闭loading
              if (loading) {
                loading.close();
              }
              console.error('保存失败:', _t3);
              this.$message.error('保存失败: ' + (_t3.message || '未知错误'));
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 5]]);
      }));
      function handleSave() {
        return _handleSave.apply(this, arguments);
      }
      return handleSave;
    }(),
    // 预览配置
    handlePreview: function () {
      var _handlePreview = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var loadingInstance, ids, previewData, response, _t4;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(this.selectedRows.length === 0)) {
                _context4.next = 1;
                break;
              }
              this.$message.warning('请至少选择一条数据进行预览');
              return _context4.abrupt("return");
            case 1:
              loadingInstance = null;
              _context4.prev = 2;
              if (!(this.selectedRows.length === 0)) {
                _context4.next = 3;
                break;
              }
              this.$message.warning('请选择一条数据进行预览');
              return _context4.abrupt("return");
            case 3:
              if (!(this.selectedRows.length > 1)) {
                _context4.next = 4;
                break;
              }
              this.$message.warning('只能选择一条数据进行预览');
              return _context4.abrupt("return");
            case 4:
              ids = this.selectedRows.map(function (item) {
                return item.id;
              }); // 构造预览参数
              previewData = {
                ids: ids,
                pageCode: this.pageKey,
                optionCode: this.moduleKey,
                xcxType: this.xcxType,
                pageURl: "" // 设置默认页面URL，可根据实际需求调整
              }; // 显示加载loading状态
              loadingInstance = this.$loading({
                lock: true,
                text: '预览生成中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              // 调用福利社预览接口
              _context4.next = 5;
              return (0, _decorateConfigItem.welfarePreview)(previewData);
            case 5:
              response = _context4.sent;
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              if (response.code === 200) {
                // 预览成功，显示返回的图片
                if (response.data) {
                  // 检查是否有二维码URL直接返回
                  if (response.data.image && typeof response.data.image === 'string') {
                    // 如果返回了二维码URL，显示预览弹窗
                    this.previewImageUrl = response.data.image;
                    this.previewVisible = true;
                  } else {
                    this.$message.success('预览二维码生成成功');
                  }
                } else {
                  this.$message.success('预览二维码生成成功');
                }
              } else {
                this.$message.error(response.message || '预览失败!');
              }
              _context4.next = 7;
              break;
            case 6:
              _context4.prev = 6;
              _t4 = _context4["catch"](2);
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              console.error('预览失败:', _t4);
              this.$message.error('预览失败: ' + (_t4.message || '未知错误'));
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[2, 6]]);
      }));
      function handlePreview() {
        return _handlePreview.apply(this, arguments);
      }
      return handlePreview;
    }(),
    // 处理预览弹窗关闭
    handlePreviewClose: function handlePreviewClose() {
      this.previewVisible = false;
      // 释放图片URL对象
      if (this.previewImageUrl) {
        URL.revokeObjectURL(this.previewImageUrl);
        this.previewImageUrl = '';
      }
    },
    // 加载配置 - 使用新的福利社接口
    loadConfig: function () {
      var _loadConfig = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this3 = this;
        var params, response, _t5;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              // 显示加载loading状态
              this.loading = true;

              // 调用后端接口获取配置项列表 - 使用新的福利社接口
              params = {
                page: this.currentPage,
                size: this.pageSize,
                name: this.searchForm.name // 传递搜索名称参数
              };
              _context5.next = 1;
              return (0, _decorateConfigItem.getWelfarePage)(params);
            case 1:
              response = _context5.sent;
              // 关闭loading
              this.loading = false;
              if (response.code === 200 && response.records) {
                // 解析配置信息 - 适配后端实体类字段
                this.list = response.records.map(function (item) {
                  // 将时间戳转换为日期字符串
                  var startTimeStr = item.startTime ? _this3.formatDateTime(item.startTime) : '';
                  var endTimeStr = item.endTime ? _this3.formatDateTime(item.endTime) : '';
                  return {
                    id: item.id,
                    name: item.name || '',
                    // 对应后端 name 字段
                    imageUrl: item.imageUrl || '',
                    // 对应后端 image_url 字段
                    type: item.type !== undefined ? item.type : 0,
                    // 对应后端 type 字段
                    enable: item.enable !== undefined ? item.enable : true,
                    createTime: item.createTime ? _this3.formatDateTime(item.createTime) : '',
                    // 格式化创建时间
                    updateTime: item.updateTime ? _this3.formatDateTime(item.updateTime) : '',
                    // 格式化更新时间
                    startTime: startTimeStr,
                    // 对应后端 start_time 字段，转换为日期字符串
                    endTime: endTimeStr,
                    // 对应后端 end_time 字段，转换为日期字符串
                    shopids: item.shopids || [] // 对应后端 shopids 字段，多选数据
                  };
                });
                this.total = response.total;
                this.currentPage = response.current;
                this.pageSize = response.size;
              } else if (response.code !== 200) {
                this.$message.error(response.message || '配置加载失败!');
              }
              // 如果response.records为空，说明还没有保存过配置，使用默认值
              _context5.next = 3;
              break;
            case 2:
              _context5.prev = 2;
              _t5 = _context5["catch"](0);
              // 关闭loading
              this.loading = false;
              console.error('配置加载失败:', _t5);
              this.$message.error('配置加载失败: ' + (_t5.message || '未知错误'));
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function loadConfig() {
        return _loadConfig.apply(this, arguments);
      }
      return loadConfig;
    }(),
    // 新增
    handleAdd: function handleAdd() {
      this.dialogTitle = '新增背景图';
      this.isEdit = false;
      this.currentId = null;

      // 初始化表单数据
      this.formData = {
        name: '',
        imageUrl: '',
        type: 0,
        // 默认为0
        enable: true,
        startTime: '',
        endTime: '',
        shopids: [] // 初始化为空数组
      };

      // 初始化时间范围
      this.timeRange = [];
      this.dialogVisible = true;
    },
    // 编辑
    handleEdit: function () {
      var _handleEdit = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(row) {
        var response, item, startDate, endDate, _t6;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.dialogTitle = '编辑背景图';
              this.isEdit = true;
              this.currentId = row.id;
              _context6.prev = 1;
              _context6.next = 2;
              return (0, _decorateConfigItem.getWelfareDetail)(row.id);
            case 2:
              response = _context6.sent;
              if (response.code === 200 && response.data) {
                item = response.data; // 填充表单数据
                this.formData = {
                  name: item.name || '',
                  imageUrl: item.imageUrl || '',
                  type: item.type !== undefined ? item.type : 0,
                  enable: item.enable !== undefined ? item.enable : true,
                  startTime: item.startTime || '',
                  endTime: item.endTime || '',
                  shopids: JSON.parse(item.shopids) || [] // 确保shopids是数组
                };

                // 设置时间范围 - 需要将时间戳转换为日期对象
                if (item.startTime || item.endTime) {
                  // 注意：这里需要将时间戳转换为日期对象，因为时间选择器需要日期对象
                  startDate = item.startTime ? new Date(parseInt(item.startTime)) : null;
                  endDate = item.endTime ? new Date(parseInt(item.endTime)) : null;
                  this.timeRange = [startDate, endDate];
                } else {
                  this.timeRange = [];
                }
                this.dialogVisible = true;
              } else {
                this.$message.error(response.message || '获取详情失败!');
              }
              _context6.next = 4;
              break;
            case 3:
              _context6.prev = 3;
              _t6 = _context6["catch"](1);
              console.error('获取详情失败:', _t6);
              this.$message.error('获取详情失败: ' + (_t6.message || '未知错误'));
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[1, 3]]);
      }));
      function handleEdit(_x2) {
        return _handleEdit.apply(this, arguments);
      }
      return handleEdit;
    }(),
    // 删除
    handleDelete: function handleDelete(row) {
      var _this4 = this;
      this.$confirm('确定要删除该背景图吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var response, _t7;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 1;
              return (0, _decorateConfigItem.deleteWelfare)(row.id);
            case 1:
              response = _context7.sent;
              if (!(response.code === 200)) {
                _context7.next = 3;
                break;
              }
              _this4.$message.success('删除成功');
              // 重新加载数据
              _context7.next = 2;
              return _this4.loadConfig();
            case 2:
              _context7.next = 4;
              break;
            case 3:
              _this4.$message.error(response.message || '删除失败!');
            case 4:
              _context7.next = 6;
              break;
            case 5:
              _context7.prev = 5;
              _t7 = _context7["catch"](0);
              console.error('删除失败:', _t7);
              _this4.$message.error('删除失败: ' + (_t7.message || '未知错误'));
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[0, 5]]);
      }))).catch(function () {
        _this4.$message.info('已取消删除');
      });
    },
    // 状态切换
    handleStatusChange: function () {
      var _handleStatusChange = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee8(row) {
        var response, _t8;
        return regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 1;
              return (0, _decorateConfigItem.updateWelfareEnable)({
                id: row.id,
                enable: row.enable
              });
            case 1:
              response = _context8.sent;
              if (!(response.code === 200)) {
                _context8.next = 3;
                break;
              }
              this.$message.success('状态更新成功');
              // 重新加载数据
              _context8.next = 2;
              return this.loadConfig();
            case 2:
              _context8.next = 4;
              break;
            case 3:
              this.$message.error(response.message || '状态更新失败!');
              // 恢复状态
              row.enable = !row.enable;
            case 4:
              _context8.next = 6;
              break;
            case 5:
              _context8.prev = 5;
              _t8 = _context8["catch"](0);
              console.error('状态更新失败:', _t8);
              this.$message.error('状态更新失败: ' + (_t8.message || '未知错误'));
              // 恢复状态
              row.enable = !row.enable;
            case 6:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[0, 5]]);
      }));
      function handleStatusChange(_x3) {
        return _handleStatusChange.apply(this, arguments);
      }
      return handleStatusChange;
    }(),
    // 提交表单 - 根据是新增还是编辑调用不同的接口
    submitForm: function submitForm() {
      var _this5 = this;
      this.$refs.form.validate(/*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee9(valid) {
          var startTimeStamp, endTimeStamp, data, _loading2, response, _t9;
          return regeneratorRuntime.wrap(function (_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                if (!valid) {
                  _context9.next = 11;
                  break;
                }
                _context9.prev = 1;
                // 将时间转换为时间戳
                startTimeStamp = null;
                endTimeStamp = null; // 如果时间范围有值，则从中提取时间戳
                if (_this5.timeRange && _this5.timeRange.length === 2) {
                  startTimeStamp = _this5.timeRange[0] ? new Date(_this5.timeRange[0]).getTime() : null;
                  endTimeStamp = _this5.timeRange[1] ? new Date(_this5.timeRange[1]).getTime() : null;
                }

                // 构造提交数据 - 与后端实体类字段完全匹配
                data = {
                  id: _this5.isEdit ? _this5.currentId : null,
                  name: _this5.formData.name,
                  // 对应后端 name 字段
                  imageUrl: _this5.formData.imageUrl,
                  // 对应后端 image_url 字段
                  type: _this5.formData.type,
                  // 对应后端 type 字段
                  startTime: startTimeStamp,
                  // 对应后端 start_time 字段，转换为时间戳
                  endTime: endTimeStamp,
                  // 对应后端 end_time 字段，转换为时间戳
                  shopList: _this5.formData.shopids,
                  // 对应后端 shopids 字段，多选数据
                  enable: _this5.formData.enable,
                  // 保持 enable 字段
                  pageCode: _this5.pageKey,
                  optionCode: _this5.moduleKey
                }; // 显示保存loading状态
                _loading2 = _this5.$loading({
                  lock: true,
                  text: '保存中...',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                });
                _context9.prev = 2;
                if (!_this5.isEdit) {
                  _context9.next = 4;
                  break;
                }
                _context9.next = 3;
                return (0, _decorateConfigItem.updateWelfare)(data);
              case 3:
                response = _context9.sent;
                _context9.next = 6;
                break;
              case 4:
                _context9.next = 5;
                return (0, _decorateConfigItem.addWelfare)(data);
              case 5:
                response = _context9.sent;
              case 6:
                if (!(response.code === 200)) {
                  _context9.next = 7;
                  break;
                }
                _this5.$message.success(_this5.isEdit ? '编辑成功' : '新增成功');
                // 重新加载数据
                _this5.dialogVisible = false;
                _context9.next = 7;
                return _this5.loadConfig();
              case 7:
                _context9.prev = 7;
                // 确保loading总是被关闭
                _loading2.close();
                return _context9.finish(7);
              case 8:
                _context9.next = 10;
                break;
              case 9:
                _context9.prev = 9;
                _t9 = _context9["catch"](1);
              case 10:
                _context9.next = 12;
                break;
              case 11:
                console.log('表单验证失败!');
                return _context9.abrupt("return", false);
              case 12:
              case "end":
                return _context9.stop();
            }
          }, _callee9, null, [[1, 9], [2,, 7, 8]]);
        }));
        return function (_x4) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    // 处理对话框关闭
    handleDialogClose: function handleDialogClose() {
      this.$refs.form.resetFields();
      this.dialogVisible = false;
    },
    // 分页大小改变
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.loadConfig();
    },
    // 当前页改变
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.loadConfig();
    },
    // 处理时间范围变化
    handleTimeRangeChange: function handleTimeRangeChange(value) {
      // 直接将值保存到timeRange变量中，不需要额外处理
      // 时间戳转换将在提交时进行
    },
    // 查询方法
    query: function query() {
      this.currentPage = 1;
      this.loadConfig();
    },
    // 重置搜索
    resetSearch: function resetSearch() {
      this.searchForm.name = '';
      this.currentPage = 1;
      this.loadConfig();
    },
    // 格式化日期时间
    formatDateTime: function formatDateTime(timestamp) {
      if (!timestamp) return '';
      var date = new Date(timestamp);
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      var hours = String(date.getHours()).padStart(2, '0');
      var minutes = String(date.getMinutes()).padStart(2, '0');
      var seconds = String(date.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    },
    // 获取门店和区域数据
    loadStoreAndRegionData: function () {
      var _loadStoreAndRegionData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee0() {
        var storeResponse, regionResponse, _t0;
        return regeneratorRuntime.wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              _context0.prev = 0;
              _context0.next = 1;
              return (0, _shopList.getStoreAllData)();
            case 1:
              storeResponse = _context0.sent;
              if (storeResponse.code === 200 && storeResponse.data) {
                this.storeList = storeResponse.data;
              }

              // 获取所有区域数据
              _context0.next = 2;
              return (0, _shopList.getStoreRegionAllData)();
            case 2:
              regionResponse = _context0.sent;
              if (regionResponse.code === 200 && regionResponse.data) {
                this.regionList = regionResponse.data;
              }
              _context0.next = 4;
              break;
            case 3:
              _context0.prev = 3;
              _t0 = _context0["catch"](0);
              console.error('获取门店或区域数据失败:', _t0);
              this.$message.error('获取门店或区域数据失败: ' + (_t0.message || '未知错误'));
            case 4:
            case "end":
              return _context0.stop();
          }
        }, _callee0, this, [[0, 3]]);
      }));
      function loadStoreAndRegionData() {
        return _loadStoreAndRegionData.apply(this, arguments);
      }
      return loadStoreAndRegionData;
    }(),
    // 验证门店或城市是否已选择
    validateShopIds: function validateShopIds(rule, value, callback) {
      if (this.formData.type === 1 || this.formData.type === 2) {
        if (!value || value.length === 0) {
          callback(new Error('请选择门店或城市'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    // 根据ID获取门店名称
    getStoreNameById: function getStoreNameById(id) {
      var store = this.storeList.find(function (item) {
        return item.storeId === id;
      });
      console.log(store);
      return store ? store.storeName : '';
    },
    // 根据ID获取区域名称
    getRegionNameById: function getRegionNameById(id) {
      var region = this.regionList.find(function (item) {
        return item.id === id;
      });
      return region ? region.name : '';
    },
    // 获取门店名称字符串
    getStoreNames: function getStoreNames(shopIds) {
      var _this6 = this;
      var ids = this.parseShopIds(shopIds);
      return ids.map(function (id) {
        return _this6.getStoreNameById(id);
      }).join(', ');
    },
    // 获取区域名称字符串
    getRegionNames: function getRegionNames(shopIds) {
      var _this7 = this;
      var ids = this.parseShopIds(shopIds);
      return ids.map(function (id) {
        return _this7.getRegionNameById(id);
      }).join(', ');
    },
    // 解析shopids字符串为数组
    parseShopIds: function parseShopIds(shopIds) {
      console.log(shopIds);
      if (!shopIds) return [];

      // 如果是数组格式，直接返回
      if (Array.isArray(shopIds)) return shopIds;

      // 如果是字符串格式，如 "[1,2]"
      if (typeof shopIds === 'string') {
        return JSON.parse(shopIds);
      }
      return [];
    },
    // 组件销毁前释放资源
    beforeDestroy: function beforeDestroy() {
      // 释放图片URL对象
      if (this.previewImageUrl) {
        URL.revokeObjectURL(this.previewImageUrl);
        this.previewImageUrl = '';
      }
    }
  }
};